export default __webpack_public_path__ + "static/media/GPAY1.8f01c71c.png";